module.exports = __webpack_public_path__ + "img/NL538.1ef08040.svg";